<template>
    <span>{{ computedValue | float(0)}} {{ label }}</span>
</template>
<script>
    import utils from "../utils/units";
    import * as common from "../utils/common";

    import { mapState, mapGetters } from 'vuex';

    export default {
        props: {
            // basic type check (`null` means accept any type)
            value: Number,
            originalIsCelcius: {
                type: Boolean, default: false
            }

        },
        computed: {
            //...mapState(["currentUser"]),
            ...mapGetters(["isCelcius"]),
            computedValue() {
                if (this.originalIsCelcius) {
                    return !this.isCelcius ? utils.toF(this.value) : this.value;
                } else {
                    return this.isCelcius ? utils.toC(this.value) : this.value;
                }
            },
            label() {
                return utils.tempLabel(this.isCelcius);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/TempLabel.vue